
  import { defineComponent, ref, onMounted, computed } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n/index';
  import { Actions } from '@/store/enums/StoreEnums';

  export default defineComponent({
    name: 'audit-logs-filter',
    emits: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const selectedItems = ref<any>({
        entityType: '',
        action: '',
        entityId: undefined,
        userId: undefined,
        areaId: undefined,
        dateFrom: '',
        dateTo: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = () => {
        const filters: any = {};

        if (selectedItems.value.entityType) {
          filters.entityType = selectedItems.value.entityType;
        }
        if (selectedItems.value.action) {
          filters.action = selectedItems.value.action;
        }
        if (
          selectedItems.value.entityId !== undefined &&
          selectedItems.value.entityId !== null &&
          selectedItems.value.entityId !== ''
        ) {
          filters.entityId = selectedItems.value.entityId;
        }
        if (
          selectedItems.value.userId !== undefined &&
          selectedItems.value.userId !== null &&
          selectedItems.value.userId !== ''
        ) {
          filters.userId = selectedItems.value.userId;
        }
        if (
          selectedItems.value.areaId !== undefined &&
          selectedItems.value.areaId !== null &&
          selectedItems.value.areaId !== ''
        ) {
          filters.areaId = selectedItems.value.areaId;
        }
        if (selectedItems.value.dateFrom) {
          filters.dateFrom = selectedItems.value.dateFrom;
        }
        if (selectedItems.value.dateTo) {
          filters.dateTo = selectedItems.value.dateTo;
        }

        emit('type-selected', filters);
      };

      const onReset = () => {
        selectedItems.value = {
          entityType: '',
          action: '',
          entityId: undefined,
          userId: undefined,
          areaId: undefined,
          dateFrom: '',
          dateTo: '',
        };
        emit('reset', {});
      };

      onMounted(async () => {
        await store.dispatch(Actions.GET_ALL_AREAS_LIST);
        await store.dispatch(Actions.GET_ALL_ENTITY_TYPES);

        const filter = store.getters.getAuditLogsFilter;

        if (filter?.entityType) {
          selectedItems.value.entityType = filter.entityType;
        }
        if (filter?.action) {
          selectedItems.value.action = filter.action;
        }
        if (filter?.entityId) {
          selectedItems.value.entityId = filter.entityId;
        }
        if (filter?.userId) {
          selectedItems.value.userId = filter.userId;
        }
        if (filter?.areaId) {
          selectedItems.value.areaId = filter.areaId;
        }
        if (filter?.dateFrom) {
          selectedItems.value.dateFrom = filter.dateFrom;
        }
        if (filter?.dateTo) {
          selectedItems.value.dateTo = filter.dateTo;
        }
      });

      return {
        areas: computed(() => store.getters.allListAreas || []),
        entityTypes: computed(() => store.getters.getAllEntityTypes || []),
        onSubmit,
        onReset,
        translate,
        selectedItems,
      };
    },
  });
